import styled from 'styled-components'
import { Typography } from '../typography'
import { baseTheme } from 'primsell-shared-layer/styles/theme'

export const StyledErrorWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-top: 5px;
  margin-bottom: -12px;
`
export const StyledError = styled(Typography)`
  margin-left: 10px;
  color: ${baseTheme.colors.red};
`
